import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=74a8ab66&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a8ab66')) {
      api.createRecord('74a8ab66', component.options)
    } else {
      api.reload('74a8ab66', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=74a8ab66&", function () {
      api.rerender('74a8ab66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/Home.vue"
export default component.exports